import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: 'swims', loadChildren: () => import('./swims/internal/npdes-dashboard.module').then(m => m.NPDESDashboardModule) },
    { path: 'streams', loadChildren: () => import('./swims/external/npdes-service-home.module').then(m => m.NPDESServiceHomeModule) },
];
